import React, { useState, useEffect } from 'react';

type Props = {
  checkboxList: Array<number>;
  setIsPanelClosed: React.Dispatch<React.SetStateAction<boolean>>;
  name: string;
  selectedItemsList?: any;
  children?: any;
};

export const RightMenu: React.FC<Props> = ({
  checkboxList,
  children,
  setIsPanelClosed,
  name,
  selectedItemsList,
}) => {
  const [openCloseState, setOpenCloseState] = useState<string>('Closed');

  useEffect(() => {
    if (checkboxList.length) {
      setIsPanelClosed(false);
      setOpenCloseState('Open');
    } else {
      setIsPanelClosed(true);
      setOpenCloseState('Closed');
    }
  }, [checkboxList]);

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      let propsObj: any = { openCloseState, checkboxList, name };

      if(selectedItemsList && selectedItemsList.length > 0){
        propsObj["selectedItemsList"] = selectedItemsList;
      }

      return React.cloneElement(child as React.ReactElement, propsObj);
    }
    return child;
  });

  return <React.Fragment>{childrenWithProps}</React.Fragment>;
};
